import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Wrapper from './styles';
import { PageHero } from '../../components';
import axios from 'axios';

const AboutPage = () => {
  const location = useLocation();
  const [data, setData] = useState(null);

  useEffect(() => {
    document.title = 'Mukunda Jwellers | About';

    // Scroll to the corresponding section if there's a hash in the URL
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  
  return (
    <div className='w-full h-full flex flex-col gap-6 p-6 md:p-10 text-gray-800 leading-relaxed'>
      <h1 className='text-2xl md:text-3xl font-semibold underline text-center'>
        About us
      </h1>
      <h1 className='font-bold text-lg'>
        Our Founder — Narasimha Reddy Bathi
      </h1>
      <ul className='ml-10 list-disc flex flex-col gap-2'>
        <li>
          {' '}
          Mukunda Jewellers was founded with the simple but powerful belief that
          jewellery should do more than shine — it should tell a story.
        </li>
        <li>
          {' '}
          Under the leadership of Narasimha Reddy Bathi, we launched the
          first-ever jewellery factory outlet in Hyderabad, bringing together
          traditional craftsmanship and modern design under one roof.
        </li>
        <li>
          His commitment to quality, artistry, and customer-centric service
          shapes everything we do.
        </li>
      </ul>
      <h2 className='font-bold text-lg'>Our Team </h2>
      <ul className='ml-10 list-disc flex flex-col gap-2'>
        <li>
          Mukunda Jewellers is backed by a dedicated team of directors and
          professionals — Ramana Bathi, Ashutosh Reddy Bathi, Ashish Reddy Bathi, Kommera
          Nikitha Reddy, Naga Srikrishna Dachepalli, Naredla Brundha Reddy, Narayana Murthy Akula, and
          others — who share the same vision of creating meaningful jewellery
          experiences.
        </li>
        <li>
          United by a passion for elegance and excellence, they ensure that each
          piece we offer lives up to the trust our customers place in us.
        </li>
      </ul>
    </div>
  );
};

export default AboutPage;
